angular.module('ihestiaGridSettings', [
  'ihestiaGridTemplatesApp',
  'ihestiaCommonDirectives.istevenMultiSelectMerged',
  'ihestiaSsoBase',
  'dndLists',
  'ihestiaCommonDirectives.breadCrumbs'
]);
